<template src="./index.html" />
<script>
import FouPicture from 'components/tools/fou-picture/'
import { mapGetters, mapActions } from 'vuex'
import AnimationProcessing from 'components/animations/processing'
import FouContainer from 'components/tools/fou-container/'
import ReviewStatusIcons from 'src/pages/submissions/components/review-status-icons/'
import FouGrid from 'src/components/layout/fou-grid/'
import FouSelectTags from 'components/form/fou-select-tags/'
import RejectionHistory from './rejection-history/'
import PreviewComputed from 'src/pages/sign-up/components/preview.computed'
import MISC from 'src/utils/helper/misc'
import TextEditor from '../../components/form/text-editor/index.vue'

export default {
  name: 'ApplicationPreview',
  data() {
    return {
      imageSrc: './../../../../../../assets/images/Commitment_to_customers.png',
      status: '',
      description: '',
      isEllipsisActive: false
    }
  },
  methods: {
    ...mapActions('signUp', ['getApplicationByAppID', 'updateApplication']),
    setStatus(status) {
      this.status = status
    },
    getIdFromRoute() {
      const routeParams = this.$route?.params || {};
      if (routeParams.hasOwnProperty('id')) {
        return String(routeParams.id)
      }
      return null
    },
    setApplicationToSubmit() {
      const requestPayload = {
        applicationStatus: this.status,
        message: { description: this.description, sentBy: this.userName }
      }
      this.$store.commit('signUp/setSignUpApplicationSteps', requestPayload)
      this.$refs.submitBtn.disabled = true
    },
    submit() {
      this.setApplicationToSubmit()
      this.updateApplication(this.getIdFromRoute()).then(res => {
        this.$router.push({
          name: 'application'
        })
      })
    }
  },
  created() {
    window.scrollTo(0, 0)
    this.getApplicationByAppID(this.getIdFromRoute())
  },
  components: {
    FouPicture,
    AnimationProcessing,
    FouContainer,
    ReviewStatusIcons,
    ...FouGrid,
    RejectionHistory,
    FouSelectTags,
    TextEditor
  },
  computed: {
    ...mapGetters('signUp', {
      steps: ['getSignUpApplicationSteps'],
      appSpinner: ['applicationLoader']
    }),
    ...PreviewComputed,
    disabledBtn() {
      return this.status === ''
    },
    applicationStatus() {
      return this.steps.applicationStatus === 'in_review'
    },
    userName() {
      return this.$store.getters['auth/user'].name
    },
    rejectionHistory() {
      if (this.steps.hasOwnProperty('messageHistory')) {
        return this.steps.messageHistory.filter(item => item.applicationStatus === 'rejected')
      }
      return []
    }
  },
  updated() {
    if (document.getElementById('foundryNameLabel') !== null) {
      this.isEllipsisActive = MISC.isEllipsisActive(document.getElementById('foundryNameLabel'))
    }
  },
  beforeUnmount() {
    let signUpApplicationSteps = {
      userId: '',
      message: {},
      applicationStatus: '',
      agreement: {},
      foundry: {},
      designers: {},
      existingDesigners: [],
      predictionScore: '',
    }
    if (this.steps.hasOwnProperty('messageHistory')) {
      signUpApplicationSteps = { ...signUpApplicationSteps, messageHistory: [] }
    }
    this.$store.commit('signUp/setSignUpApplicationSteps', signUpApplicationSteps)
  }
}
</script>
<style src="./stylesheets/index.scss" lang="scss" module></style>
<style src="./stylesheets/rte.scss" lang="scss" scoped></style>
